import React from "react";
import { Tabs, Tab, Row, Col } from "react-bootstrap";
import SearchableDropdown from "components/SearchableDropdown";
// import AssessmentInfoBox from 'components/InvitationSettings/AssessmentInfoBox';
import { array, func } from "prop-types";

// Video Interview tab commented out until the backend is complete
const TestingTabs = ({
  testBatteries,
  individualTestOptions,
  onSelectTab,
  chosenTests,
  handleSubTestChoice,
  // currentCandidateStageHasVi
}) => (
  <div>
    <h4 className="mb-3">Testing</h4>
    <Tabs defaultActiveKey="selectBattery" onSelect={onSelectTab}>
      <Tab eventKey="selectBattery" title="Select a Battery">
        <Row>
          <Col>{testBatteries}</Col>
        </Row>
      </Tab>
      <Tab eventKey="selectSpecificTest" title="Select Specific Test(s)">
        <div className="mt-3">{chosenTests}</div>
        <Row className="mt-3">
          <Col sm={4} md={4} lg={4}>
            <SearchableDropdown
              id="individualTestOptions"
              options={individualTestOptions}
              onChange={handleSubTestChoice}
              placeholder="Add a Test"
              alwaysShowPlaceholder
              width="324px"
            />
          </Col>
        </Row>
      </Tab>
      {/* {currentCandidateStageHasVi ? (
        <Tab eventKey="videoInterview" title="Video Interviews">
          <Row className="mt-3">
            <AssessmentInfoBox videoInterview/>
          </Row>
        </Tab>
      ) : null} */}
    </Tabs>
  </div>
);

TestingTabs.propTypes = {
  testBatteries: array,
  individualTestOptions: array,
  onSelectTab: func,
  chosenTests: array,
  handleSubTestChoice: func,
  // currentCandidateStageHasVi: bool
};

export default TestingTabs;
